import { apiFetch } from '../utils/api';

export interface SyncLog {
  id: string;
  erpEndpoint: string;
  status: 'pending' | 'success' | 'failed';
  responseStatusCode?: number | null;
  errorMessage?: string | null;
  startedAt?: string | null;
  finishedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedLogsResponse {
  data: SyncLog[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchSyncLogs = (params: { page?: number; limit?: number; status?: 'pending' | 'success' | 'failed' } = {}): Promise<PaginatedLogsResponse> => {
  const sp = new URLSearchParams();
  if (params.page) sp.set('page', String(params.page));
  if (params.limit) sp.set('limit', String(params.limit));
  if (params.status) sp.set('status', params.status);
  const q = sp.toString();
  return apiFetch<PaginatedLogsResponse>(`/sync-data/logs${q ? `?${q}` : ''}`);
}
